// Credit pricing rules. Mirror of the SQL in migrations/004_projects_v2.sql.
//
//   queries_per_project = review_cap *
//                         sum_over_topics( (1 + #competitors) * (5 + #custom_questions) )
//   quoted_credits      = max(1, 1 + queries_per_project / 1_000_000)
//
// Canned assessments (NPS, pricing, competitive comparison, leaver-joiner) cost
// nothing extra — they reuse the same review data, so no new HN-API queries.

export const SEARCHES_PER_POST_BASE = 5;
export const SEARCHES_PER_CREDIT = 1_000_000;
export const BASE_CREDITS = 1;

export function topicQueryDemand({ competitorCount = 0, customQuestionCount = 0 } = {}) {
    return (1 + competitorCount) * (SEARCHES_PER_POST_BASE + customQuestionCount);
}

export function totalQueries(reviewCap, topics) {
    if (!topics || topics.length === 0) return reviewCap * SEARCHES_PER_POST_BASE;
    const demand = topics.reduce((acc, t) => acc + topicQueryDemand(t), 0);
    return reviewCap * demand;
}

export function quotedCredits(reviewCap, topics) {
    const queries = totalQueries(reviewCap, topics);
    return Math.max(BASE_CREDITS, BASE_CREDITS + queries / SEARCHES_PER_CREDIT);
}

export function formatCredits(value) {
    return Number(value).toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    });
}

export function formatNumber(value) {
    return Number(value).toLocaleString();
}

export const REVIEW_CAP_STOPS = [
    10_000,
    50_000,
    100_000,
    500_000,
    1_000_000,
    2_000_000,
    5_000_000,
];

export function formatReviewCount(n) {
    if (n >= 1_000_000) return `${(n / 1_000_000).toLocaleString(undefined, { maximumFractionDigits: 1 })}M`;
    if (n >= 1_000) return `${(n / 1_000).toLocaleString()}k`;
    return String(n);
}

export const CANNED_ASSESSMENTS = [
    { id: 'nps', label: 'NPS' },
    { id: 'pricing', label: 'Willingness-to-Pay' },
    { id: 'competitive_comparison', label: 'Competitive Comparison' },
    { id: 'leaver_joiner', label: 'Leaver / Joiner' },
];
